// extracted by mini-css-extract-plugin
export var backarrow = "BurgerMenuMobile-module--backarrow--77752";
export var burgermenucontainer = "BurgerMenuMobile-module--burgermenucontainer--e9b11";
export var burgermenuhidden = "BurgerMenuMobile-module--burgermenuhidden--ad8df";
export var primarylink = "BurgerMenuMobile-module--primarylink--6ddec";
export var primarylinkactive = "BurgerMenuMobile-module--primarylinkactive--6594f BurgerMenuMobile-module--primarylink--6ddec";
export var primarynavlist = "BurgerMenuMobile-module--primarynavlist--e59a3";
export var secondarylink = "BurgerMenuMobile-module--secondarylink--2d033";
export var secondarylinkactive = "BurgerMenuMobile-module--secondarylinkactive--42c4f BurgerMenuMobile-module--secondarylink--2d033";
export var secondarynavhidden = "BurgerMenuMobile-module--secondarynavhidden--7734d";
export var secondarynavlist = "BurgerMenuMobile-module--secondarynavlist--8b995";
export var secondarynavwrapper = "BurgerMenuMobile-module--secondarynavwrapper--ac4d1";
export var secondarytitle = "BurgerMenuMobile-module--secondarytitle--a3da1";
export var subMenuNavArrows = "BurgerMenuMobile-module--subMenuNavArrows--c0d94";
export var tertiarylink = "BurgerMenuMobile-module--tertiarylink--13276";
export var tertiarynavlist = "BurgerMenuMobile-module--tertiarynavlist--0945a";
export var tertiarynavwrapper = "BurgerMenuMobile-module--tertiarynavwrapper--47ec6";